<section class="service-details">
    <div class="row fc-service-breadcrumb">
        <div class="col-8">
            <button class="teams-btn" [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Help Click'" (click)="navigateToTeams()">
                Need Help ?<span><img src="../../../../assets/imagesV4/footer-Teams.svg" mattooltip="Teams" mattooltipposition="above" class="mat-mdc-tooltip-trigger"></span>
            </button>
        </div>
        <div class="col-4">
            <div>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/landing-page']">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">Forecast Service Details</li>
                        <li>
                            <button [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Documentation'"
                                class="uitk-icon uitk-icon-info_hollow md-icon border-0" title="Info" (click)="info()">
                            </button>
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <div class="stk-table-loader fc-service-loader" *ngIf="showLoader">
        <app-loader>
        </app-loader>
    </div>
    <div *ngIf="!showLoader && dataSource">
        <div class="master-card-section margin-botton-5">
            <app-forecast-master-card [masterData]="masterData" [dataSource]="dataSource"
                [currentYear]="currentYear"></app-forecast-master-card>
        </div>
        <div class="ac-fc-section margin-botton-5">
            <mat-accordion>
                <mat-expansion-panel #panel expanded (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                    <mat-expansion-panel-header class="panel-header p-0" hideToggle="true">
                        <mat-panel-title class="w-100">
                            <div class="row accordion-heading-row me-0">
                                <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 flex-container">
                                    <div class="flex-item title-item"  (click)="$event.stopPropagation()">
                                        <label
                                            class="card-heading  Infrastructure Services tile-heading table-Header-Nav-font no-wrap-label">
                                            <mat-icon class="expansion-icon" (click)="togglePanel($event, panel)">{{panel.expanded ? 'keyboard_arrow_down' :
                                                'keyboard_arrow_right'}}</mat-icon>
                                                <span>{{showCharge ? 'Actuals & Forecast By Charge' : 'Actuals & Forecast By Volume' }}</span> </label>
                                    </div>
                                    <div class="flex-item decom-item" (click)="$event.stopPropagation()">
                                        <label *ngIf="masterData?.decom_date"
                                            class="card-heading  Infrastructure Services tile-heading table-Header-Nav-font h-100 no-wrap-label">Decom Validation Date:<span class="black-text ms-1">{{
                                                masterData?.decom_date|date:'longDate'}}</span></label>
                                    </div>
                                    <div class="flex-item" (click)="$event.stopPropagation()">
                                        <label [ngClass]="{'hide-msg': !checkDecomFCData()}"
                                            class="decom-msg h-100">Forecast added for post planned Decommission
                                            Months</label>
                                    </div>


                                </div>

                                <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4  table-actions"
                                    (click)="$event.stopPropagation()">
                                    <div class="switch-toggle-div">
                                        <label class="switch-toggle-label costview-info-font me-2 mb-0">By
                                            Volume</label>
                                        <mat-slide-toggle [color]="'#013b71'" style="float:right;"
                                            (change)="apptoggle($event)" class="app-toggle">
                                        </mat-slide-toggle>
                                        <label class="switch-toggle-label costview-info-font ms-2 mb-0">By
                                            Charge</label>
                                        <div class="export-link ps-3">
                                            <span class="me-3" (click)="openReportLink()"  title="Click to view the infrastructure consumption details" >
                                                <img class="add-report-link-img" src="../../../../assets/imagesV4/Link.png">
                                            </span>
                                            <span
                                            [attr.Pixel-tracking]="true" [attr.Pixel-title]="'Download'"
                                                class="uitk-icon uitk-icon-download md-icon excel_Download excelandinfo-Icon-font"
                                                title="Click to download" (click)="excelDownload()"></span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div (click)="$event.stopPropagation()">
                                <div class="row m-0 table-row" *ngIf="panelOpenState">
                                    <div class="col-12 table-container p-0 ac-fc-table" [hidden]="showCharge">
                                        <mat-table *ngIf="volumeACdataSource.length" [dataSource]="volumeACdataSource">
                                            <ng-container *ngFor="let column of displayedColumns"
                                                [matColumnDef]="column">
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-header-cell *matHeaderCellDef class="actual-yr-col">Actuals By
                                                        Year</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-cell *matCellDef="let element" class="actual-yr-val">
                                                        <div class="column-container">
                                                            <span>{{element[column]}}</span>
                                                            <p class="total_txt">Total: {{element['total'] |number:'1.0-0'}}</p>
                                                        </div>
                                                    </mat-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-cell *matCellDef="let element">
                                                        <span>
                                                            {{element[column] |number:'1.0-0'}}</span>
                                                    </mat-cell>
                                                </ng-container>

                                            </ng-container>
                                            <mat-header-row *matHeaderRowDef=" displayedColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                    </div>
                                    <div class="col-12 table-container p-0 ac-fc-table" [hidden]="!showCharge">
                                        <mat-table *ngIf="chargeACdataSource.length" [dataSource]="chargeACdataSource">
                                            <ng-container *ngFor="let column of displayedColumns"
                                                [matColumnDef]="column">
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-header-cell *matHeaderCellDef class="actual-yr-col">Actuals By
                                                        Year</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-cell *matCellDef="let element" class="actual-yr-val">
                                                        <div class="column-container">
                                                            <span>{{element[column]}}</span>
                                                            <p class="total_txt">Total: ${{element['total'] |
                                                                number:'1.0-0'}}</p>
                                                        </div>
                                                    </mat-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-cell *matCellDef="let element">
                                                        <span *ngIf="(element[column]||element[column]==0)">
                                                            ${{element[column] |
                                                            number:'1.0-0'}}</span>
                                                    </mat-cell>
                                                </ng-container>
                                            </ng-container>
                                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                    </div>

                                </div>
                                <div class="row forecast-action-row m-0 ms-3">
                                    <div class="col-9 ps-5">
                                        <div class="d-flex">
                                            <div class="flex-item">
                                                <mat-icon aria-hidden="false" *ngIf="masterData.Attested_By != null" class="check-icon greenbg" fontIcon="check_circle"></mat-icon>
                                                <mat-icon aria-hidden="false" *ngIf="masterData.Attested_By_Offc != null" class="check-icon purplebg" fontIcon="check_circle"></mat-icon>
                                                <label>Forecast</label>
                                            </div>
                                            <div class="flex-item forecast-notification-txt" *ngIf="forecastCycleType?.msg">
                                                <label class="forecast-msg h-100" >{{forecastCycleType?.msg}}<span *ngIf="forecastCycleType?.msg2" class="edit-txt">{{forecastCycleType?.msg2}}</span><span *ngIf="forecastCycleType?.msg3">{{forecastCycleType?.msg3}}</span><span *ngIf="forecastCycleType?.submsg" [ngClass]="forecastCycleType?.type"> {{forecastCycleType?.submsg}}</span></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-3 forecast-action-item">
                                        <button *ngIf="!showCharge && currentMode=='normal'"
                                            [disabled]="!checkEditAccess()"   
                                            (click)="editFC('normal')"
                                            class="add-apply uitk-c-button uitk-c-button--default techops-global-button button-size m-1 me-1">Edit</button>
                                        <button *ngIf="!showCharge && currentMode=='edit'"
                                            (click)="editFC('edit')"
                                            class="add-apply uitk-c-button uitk-c-button--default techops-global-button button-size m-1">Cancel</button>
                                        <button *ngIf="!showCharge "
                                            [disabled]="currentMode=='normal' || !checkEditAccess()"
                                            (click)="showAttestationPopup()"
                                            class="add-apply uitk-c-button uitk-c-button--default techops-global-button button-size m-1">{{forecastCycleType?.type =='Off-cycle' ? 'Apply' : 'Apply & attest'}}</button>
                                    </div>

                                </div>
                                <div class="row m-0 table-row pb-3">
                                    <div class="col-12 table-container p-0 ac-fc-table forecast-table"
                                        [hidden]="showCharge" *ngIf="volumeFCdataSource">
                                        <mat-table [dataSource]="volumeFCdataSource['firstTable']">
                                            <ng-container *ngFor="let column of displayedColumns"
                                                [matColumnDef]="column">
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-header-cell *matHeaderCellDef class="actual-yr-col">{{forecastCycleType?.type == 'Off-cycle' ? 'Update Cycle' : 'Forecast Cycle'}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-cell *matCellDef="let element">
                                                        <input type="text" appIntegerOnly [allowNegative]=allowNegative appDisableDragDrop
                                                            *ngIf="enableEdit(element,column) && currentMode=='edit' && element['label']!='Variance'"
                                                            [(ngModel)]="element[column]"
                                                            (keyup)="onChange(element[column],column,element,$event)"
                                                            class="blue-text" (keydown)="$event.stopPropagation()"
                                                            [ngClass]="{'red-border': checkDecomFCMonth(element,column)}" />
                                                        <span
                                                            *ngIf=" column!='Year' && element['label']!='Variance' && (!enableEdit(element,column)||enableEdit(element,column)&& currentMode=='normal')"
                                                            [ngClass]="gettextcolor(element,column)">{{ element[column]
                                                            ?
                                                            (element[column]) : 0}}</span>
                                                        <span *ngIf="column!='Year' && element['label']=='Variance'" class="Variance">
                                                            {{(element[column]|number:'1.0-0')}}<sub>{{getPercentage(column,element)}}</sub></span>

                                                    </mat-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">

                                                    <mat-cell *matCellDef="let element" class="actual-yr-val">
                                                        <ng-container *ngIf="element['label']!='Variance'">
                                                            <div class="column-container">
                                                                <span 
                                                                matTooltip="{{ element['tooltip'] }}"
                                                                matTooltipClass="my-custom-tooltip"
                                                                matTooltipPosition="above" [innerHtml]="element['label']" class="forecast_cycle_label"></span>
                                                                
                                                                <p class="total_txt"><img src="/assets/imagesV4/copyimg.png" *ngIf="element['cycle'] !='current' && currentMode=='edit'" (click)="copyToCurrent(element) ; $event.stopPropagation();" [matTooltip]="getCopyIconToolTipMsg(element)" matTooltipClass="my-custom-tooltip" matTooltipPosition="below" class="copy-img"> Total: {{element['total'] |
                                                                    number:'1.0-0'}}</p>
                                                            </div>
                                                        </ng-container>
                                                        <span *ngIf="element['label']=='Variance'"
                                                            class="variance-cell">{{element['label']}}</span>
                                                    </mat-cell>
                                                </ng-container>

                                            </ng-container>
                                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                        <mat-table [dataSource]="volumeFCdataSource['secondTable']">
                                            <ng-container *ngFor="let column of displayedColumns"
                                                [matColumnDef]="column">
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-header-cell *matHeaderCellDef class="actual-yr-col">Forecast
                                                        Cycle</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-cell *matCellDef="let element">
                                                        <input type="text" appIntegerOnly [allowNegative]=allowNegative appDisableDragDrop
                                                            *ngIf="enableEdit(element,column) && currentMode=='edit' && element['label']!='Variance'"
                                                            [(ngModel)]="element[column]"
                                                            (keyup)="onChange(element[column],column,element,$event)"
                                                            class="blue-text" (keydown)="$event.stopPropagation()"
                                                            [ngClass]="{'red-border': checkDecomFCMonth(element,column)}" />
                                                        <span
                                                            *ngIf=" column!='Year' && element['label']!='Variance' && (!enableEdit(element,column)||enableEdit(element,column)&& currentMode=='normal')"
                                                            [ngClass]="gettextcolor(element,column)">{{ element[column]
                                                            ?
                                                            (element[column]) : 0}}</span>
                                                        <span *ngIf="column!='Year' && element['label']=='Variance'" class="Variance">
                                                        {{(element[column]|number:'1.0-0')}}<sub>{{getPercentage(column,element)}}</sub></span>

                                                    </mat-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-cell *matCellDef="let element" class="actual-yr-val">
                                                        <ng-container  *ngIf="element['label']!='Variance'">
                                                            <div class="column-container">
                                                                <span matTooltip="{{ element['tooltip'] }}" matTooltipClass="my-custom-tooltip" matTooltipPosition="above"
                                                                    [innerHtml]="element['label']" class="forecast_cycle_label"></span>
                                                               
                                                                    <p class="total_txt"><img src="/assets/imagesV4/copyimg.png" *ngIf="element['cycle'] !='current' && currentMode=='edit'" (click)="copyToCurrent(element) ; $event.stopPropagation();" [matTooltip]="getCopyIconToolTipMsg(element)" matTooltipClass="my-custom-tooltip" matTooltipPosition="below" class="copy-img"> Total: {{element['total'] |
                                                                    number:'1.0-0'}}</p>
                                                            </div>
                                                        </ng-container>
                                                        <span *ngIf="element['label']=='Variance'"
                                                            class="variance-cell">{{element['label']}}</span>
                                                    </mat-cell>
                                                </ng-container>

                                            </ng-container>
                                            <mat-header-row *matHeaderRowDef="displayedColumns"
                                                [class.hidden]="true"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                    </div>
                                    <div class="col-12 table-container p-0 ac-fc-table forecast-table"
                                        [hidden]="!showCharge">
                                        <mat-table [dataSource]="chargeFCdataSource['firstTable']">
                                            <ng-container *ngFor="let column of displayedColumns"
                                                [matColumnDef]="column">
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-header-cell *matHeaderCellDef class="actual-yr-col">Forecast
                                                        Cycle</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-cell *matCellDef="let element">
                                                        <span *ngIf="element['label']!='Variance'"
                                                            [ngClass]="gettextcolor(element,column)">${{element[column]
                                                            ?
                                                            element[column]: 0}}</span>
                                                        <span *ngIf="column!='Year' && element['label']=='Variance'" class="Variance">
                                                        ${{(element[column]|number:'1.0-0')}}<sub>{{getPercentage(column,element)}}</sub></span>


                                                    </mat-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-cell *matCellDef="let element" class="actual-yr-val">
                                                        <ng-container *ngIf="element['label']!='Variance'">
                                                            <div class="column-container">
                                                                <span matTooltip="{{ element['tooltip'] }}" matTooltipClass="my-custom-tooltip" matTooltipPosition="above"
                                                                    [innerHtml]="element['label']" class="forecast_cycle_label"></span>
                                                                <p class="total_txt">Total: ${{element['total'] |
                                                                    number:'1.0-0'}}</p>
                                                            </div>
                                                        </ng-container>
                                                        <span *ngIf="element['label']=='Variance'"
                                                            class="variance-cell">{{element['label']}}</span>
                                                    </mat-cell>
                                                </ng-container>

                                            </ng-container>
                                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                        <mat-table [dataSource]="chargeFCdataSource['secondTable']">
                                            <ng-container *ngFor="let column of displayedColumns"
                                                [matColumnDef]="column">
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-header-cell *matHeaderCellDef>{{column}}</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-header-cell *matHeaderCellDef class="actual-yr-col">Forecast
                                                        Cycle</mat-header-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column!='Year'">
                                                    <mat-cell *matCellDef="let element">
                                                        <span *ngIf="element['label']!='Variance'"
                                                            [ngClass]="gettextcolor(element,column)">${{element[column]
                                                            ?
                                                            element[column] : 0}}</span>
                                                        <span *ngIf="column!='Year' && element['label']=='Variance'" class="Variance">

                                                            ${{(element[column]|number:'1.0-0')}}<sub>{{getPercentage(column,element)}}</sub></span>


                                                    </mat-cell>
                                                </ng-container>
                                                <ng-container *ngIf="column=='Year'">
                                                    <mat-cell *matCellDef="let element" class="actual-yr-val">
                                                        <ng-container *ngIf="element['label']!='Variance'">
                                                            <div class="column-container">
                                                                <span matTooltip="{{ element['tooltip'] }}" matTooltipClass="my-custom-tooltip" [innerHtml]="element['label']" class="forecast_cycle_label"></span>
                                                                <p class="total_txt">Total: ${{element['total'] |
                                                                    number:'1.0-0'}}</p>
                                                            </div>
                                                        </ng-container>
                                                        <span *ngIf="element['label']=='Variance'"
                                                            class="variance-cell">{{element['label']}}</span>
                                                    </mat-cell>
                                                </ng-container>

                                            </ng-container>
                                            <mat-header-row *matHeaderRowDef="displayedColumns"
                                                [class.hidden]="true"></mat-header-row>
                                            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                        </mat-table>
                                    </div>

                                </div>
                            </div>
                            
                        </mat-panel-title>

                    </mat-expansion-panel-header>
                </mat-expansion-panel>
            </mat-accordion>
            <div class="col-12 d-flex lastModifiedSection white-bg pb-2" *ngIf="lastModified ">
                <div class="lastModified ">Last Modified by {{dataSource.updated_By}} on {{
                    (dataSource.updated_At | date: 'MMM d, y, h:mm:ss a') }}</div>
            </div>
            
        </div>
       
        <div class="col-12 mt-1 white-bg display-comments margin-botton-5 " *ngIf="forecastComments != ''">
            <div> <label class="tabl-header-font">Comments</label>
                <div class="comments-area ps-2">{{forecastComments}}</div>
            </div>
        </div>
        <div class="mt-2 height-1 margin-botton-5 " *ngIf="forecastComments == ''"></div>
        <div class=" row white-bg comments-section m-0 margin-botton-5 pb-0">
            <div class="col-12 pos-static">
                <label class="tabl-header-font">Forecast By {{showCharge ? 'Charge': 'Volume'}} Trends</label>
                <div class="graph-section">
                    <div [hidden]="chartData.length == 0">
                        <app-multi-line-chart [label]="label" [minrange]="minrange" [maxRange]="maxrange"
                            [data]="chartData"></app-multi-line-chart>
                    </div>

                    <div class="info-div">
                        <div class="pullUp first">
                            <div class="square square-size dev actuals"></div>
                            <p class="legend legend-font">Actuals</p>
                        </div>
                        <div class="pullUp">
                            <div class="square square-size om fc1"></div>
                            <p class="legend legend-font">Forecast Cycle( {{previousFC.Forecast_Cycle}} )</p>
                        </div>
                        <div class="pullUp">
                            <div class="square square-size om fc2"></div>
                            <p class="legend legend-font">Forecast Cycle( {{currentFC.Forecast_Cycle}} )</p>
                        </div>
                        <div class="pullUp">
                            <div class="square square-size om fc3"></div>
                            <p class="legend legend-font">Projections( {{currentFC.Forecast_Cycle}} )</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearall"></div>
    </div>

</section>

<app-modal [maximizable]="true" [inViewport]="true" #attestationPopup class="modal-demo attestation-popup">
    <ng-container class="app-modal-body">
        <div class="col-12 ps-0 ">
            <p class="attestation-title">{{attestation_popup_title}}</p>
            <label class="tabl-header-font">Comments</label>
            <sup *ngIf="valueExceedLmt.length>0 || this.decomcount > 0"
                class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></sup>
            <textarea [(ngModel)]="newcomments" [disabled]="!checkEditAccess() || currentMode=='normal'"
                class="w-100 form-control comments-input" cols="10" rows="5"
                [placeholder]="commentsPlaceholderText" maxlength="3000"></textarea>


            <div *ngIf="comments?.length!=3000" class="help-block uitk-c-input__message--error"
                style="background-color:green;width: 100%;">
                <span>
                    {{3000-comments?.length }} Char Left
                </span>
            </div>
            <div *ngIf="comments?.length == 3000" class="help-block uitk-c-input__message--error">
                0 Char Left
            </div>
        </div>
        <div class="d-flex attestation-button m-1">
            <button (click)="hideAttestationPopup()"
                class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size me-2">Cancel</button>
            <button (click)="submitForecast()"
                class="add-apply pull-right m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs button-size"
                [disabled]="checkBtnDisability()">Continue</button>
        </div>
    </ng-container>
</app-modal>